function t(e) {
  return {
    name: "Vala",
    keywords: {
      keyword: (
        // Value types
        "char uchar unichar int uint long ulong short ushort int8 int16 int32 int64 uint8 uint16 uint32 uint64 float double bool struct enum string void weak unowned owned async signal static abstract interface override virtual delegate if while do for foreach else switch case break default return try catch public private protected internal using new this get set const stdout stdin stderr var"
      ),
      built_in: "DBus GLib CCode Gee Object Gtk Posix",
      literal: "false true null"
    },
    contains: [
      {
        className: "class",
        beginKeywords: "class interface namespace",
        end: /\{/,
        excludeEnd: !0,
        illegal: "[^,:\\n\\s\\.]",
        contains: [e.UNDERSCORE_TITLE_MODE]
      },
      e.C_LINE_COMMENT_MODE,
      e.C_BLOCK_COMMENT_MODE,
      {
        className: "string",
        begin: '"""',
        end: '"""',
        relevance: 5
      },
      e.APOS_STRING_MODE,
      e.QUOTE_STRING_MODE,
      e.C_NUMBER_MODE,
      {
        className: "meta",
        begin: "^#",
        end: "$"
      }
    ]
  };
}
export {
  t as default
};
